export default "__VITE_ASSET__DDP7dumt__"